/* __next_internal_client_entry_do_not_use__ ModalNavigationAbsolute auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization/localize";
import * as React from "react";
import styled, { useTheme } from "styled-components";
import { Chevron } from "../../../icons/foundation/Chevron";
import { Close } from "../../../icons/foundation/Close";
import { getSpacing } from "../../../spacing";
export var ModalNavigationAbsolute = function(param) {
    var onClose = param.onClose, onBack = param.onBack, onForward = param.onForward, primary = param.primary, showCloseButton = param.showCloseButton, closeIconProps = param.closeIconProps, backIconProps = param.backIconProps, forwardIconProps = param.forwardIconProps;
    var _theme_modals;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var theme = useTheme();
    var modalTheme = (_theme_modals = theme.modals) === null || _theme_modals === void 0 ? void 0 : _theme_modals[primary ? "primary" : "default"];
    var _modalTheme_color;
    var iconColor = (_modalTheme_color = modalTheme === null || modalTheme === void 0 ? void 0 : modalTheme.color) !== null && _modalTheme_color !== void 0 ? _modalTheme_color : Core.icon.default;
    var _modalTheme_iconProps;
    var iconProps = (_modalTheme_iconProps = modalTheme === null || modalTheme === void 0 ? void 0 : modalTheme.iconProps) !== null && _modalTheme_iconProps !== void 0 ? _modalTheme_iconProps : {};
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            showCloseButton && onClose ? /*#__PURE__*/ _jsx(CloseButton, {
                className: "closeButton",
                onClick: onClose,
                "data-test-id": "modalCloseButton",
                style: {
                    padding: getSpacing("2x")
                },
                "aria-label": strictLocalize({
                    id: "YPiM+d",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Close"
                        }
                    ]
                }),
                children: /*#__PURE__*/ _jsx(Close, _object_spread({
                    color: iconColor
                }, iconProps, closeIconProps))
            }) : null,
            onBack ? /*#__PURE__*/ _jsx(BackButton, {
                className: "backButton",
                onClick: onBack,
                "data-test-id": "modalBackButton",
                "aria-label": strictLocalize({
                    id: "RAaJC5",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Back"
                        }
                    ]
                }),
                children: /*#__PURE__*/ _jsx(Chevron, _object_spread({
                    direction: "left",
                    color: iconColor
                }, iconProps, backIconProps))
            }) : null,
            onForward ? /*#__PURE__*/ _jsx(ForwardButton, {
                className: "forwardButton",
                onClick: onForward,
                "data-test-id": "modalForwardButton",
                "aria-label": strictLocalize({
                    id: "oT6SQe",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Forward"
                        }
                    ]
                }),
                children: /*#__PURE__*/ _jsx(Chevron, _object_spread({
                    direction: "right",
                    color: iconColor
                }, iconProps, forwardIconProps))
            }) : null
        ]
    });
};
/**
 * @trackcomponent
 * @supersededBy "@faire/web--source/slate/IconButton/IconButton#IconButton"
 */ var CloseButton = styled.button.withConfig({
    componentId: "sc-c0deb0e7-0"
})([
    "background:transparent;border:0;border-radius:0;outline:0;padding:10px;padding-right:",
    ";padding-top:",
    ";cursor:pointer;position:absolute;z-index:1;top:0;right:0;display:flex;justify-content:center;align-items:center;&:focus-visible{outline:-webkit-focus-ring-color auto 1px;border-radius:50px;}"
], getSpacing("2x"), getSpacing("2x"));
var BackButton = styled(CloseButton).withConfig({
    componentId: "sc-c0deb0e7-1"
})([
    "padding-right:10px;padding-left:",
    ";left:0;right:unset;"
], getSpacing("2x"));
var ForwardButton = styled(CloseButton).withConfig({
    componentId: "sc-c0deb0e7-2"
})([
    "left:64px;"
]);
